module.exports = __webpack_public_path__ + "static/media/b17.77a69e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/butterfly/b17.jpg
// module id = 463
// module chunks = 0